import { render, staticRenderFns } from "./AppFeaturesAddUpdate.vue?vue&type=template&id=4484ab08&"
import script from "./AppFeaturesAddUpdate.vue?vue&type=script&lang=js&"
export * from "./AppFeaturesAddUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports